module.exports = __webpack_public_path__ + "img/performance-8.29b3d4e9.png";